import classNames from "classnames";
import { Typography } from "PFComponents/typography";
import React, { PropsWithChildren } from "react";

import css from "./info_section.module.scss";

type InfoSectionProps = {
  title: JSX.Element | string;
  titleGray?: boolean;
};

export const InfoSection = ({
  title,
  titleGray,
  children
}: PropsWithChildren<InfoSectionProps>): JSX.Element => (
  <span className={css.infoSection}>
    <Typography variant="labelRegular" className={classNames({ [css.gray]: titleGray })}>
      {title}
    </Typography>
    {children}
  </span>
);
